import { render, staticRenderFns } from "./DailyArrival.vue?vue&type=template&id=af64f7f4&scoped=true&"
import script from "./DailyArrival.vue?vue&type=script&lang=js&"
export * from "./DailyArrival.vue?vue&type=script&lang=js&"
import style0 from "./DailyArrival.vue?vue&type=style&index=0&id=af64f7f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af64f7f4",
  null
  
)

export default component.exports